/* ============================================================
   Barn & Brass — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ---- Accordion ----------------------------------------- */
  function initAccordions(root = document) {
    root.querySelectorAll('.bb-accordion').forEach(accordion => {
      const triggers = accordion.querySelectorAll('.bb-accordion__trigger');
      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';
          triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
          trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
    });
  }

  /* ---- Header scroll ------------------------------------- */
  function initHeader() {
    const header = document.querySelector('.bb-header');
    if (!header) return;
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      header.classList.toggle('bb-header--scrolled', scrollY > 20);
      lastScroll = scrollY;
    }, { passive: true });
  }

  /* ---- Mobile nav drawer --------------------------------- */
  function initMobileNav() {
    const open = document.querySelector('.bb-header__nav-toggle');
    const close = document.querySelector('.bb-nav-drawer__close');
    const drawer = document.querySelector('.bb-nav-drawer');
    const overlay = document.querySelector('.bb-nav-overlay');
    if (!open || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      close?.focus();
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay?.classList.remove('is-visible');
      document.body.style.overflow = '';
      open.focus();
    }

    open.addEventListener('click', openDrawer);
    close?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ---- Product gallery ----------------------------------- */
  function initProductGallery() {
    const gallery = document.querySelector('.bb-product-gallery');
    if (!gallery) return;

    const mainImg = gallery.querySelector('.bb-product-gallery__main img');
    const thumbs = gallery.querySelectorAll('.bb-product-gallery__thumb');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        const srcset = thumb.dataset.srcset;
        if (mainImg && src) {
          mainImg.src = src;
          if (srcset) mainImg.srcset = srcset;
        }
        thumbs.forEach(t => t.setAttribute('aria-selected', 'false'));
        thumb.setAttribute('aria-selected', 'true');
      });
    });
  }

  /* ---- Variant selector ---------------------------------- */
  function initVariantSelector() {
    /* Handled by the inline script in sections/main-product.liquid */
  }

  /* ---- Scroll-spy TOC ------------------------------------ */
  function initScrollSpy() {
    const toc = document.querySelector('.bb-toc');
    if (!toc) return;

    const headings = document.querySelectorAll('.bb-prose h2, .bb-prose h3');
    const links = toc.querySelectorAll('a[href^="#"]');

    if (!headings.length || !links.length) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          links.forEach(link => {
            link.classList.toggle(
              'is-active',
              link.getAttribute('href') === `#${entry.target.id}`
            );
          });
        }
      });
    }, { rootMargin: '-80px 0px -60% 0px' });

    headings.forEach(h => observer.observe(h));
  }

  /* ---- Auto-generate TOC from prose headings ------------ */
  function initAutoTOC() {
    const toc = document.querySelector('.bb-toc__list');
    const prose = document.querySelector('.bb-prose');
    if (!toc || !prose) return;

    const headings = prose.querySelectorAll('h2, h3');
    headings.forEach((h, i) => {
      if (!h.id) h.id = `section-${i}`;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent;
      a.className = h.tagName === 'H3' ? 'bb-toc__link bb-toc__link--sub' : 'bb-toc__link';
      li.appendChild(a);
      toc.appendChild(li);
    });
  }

  /* ---- Blog tag filter ----------------------------------- */
  function initBlogFilter() {
    const pills = document.querySelectorAll('.bb-blog-filter .bb-pill');
    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        const tag = pill.dataset.tag;
        const url = new URL(window.location.href);
        if (tag === 'all') {
          url.searchParams.delete('tagged');
        } else {
          url.searchParams.set('tagged', tag);
        }
        window.location.href = url.toString();
      });
    });
  }

  /* ---- Init ---------------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    initAccordions();
    initHeader();
    initMobileNav();
    initProductGallery();
    initVariantSelector();
    initScrollSpy();
    initAutoTOC();
    initBlogFilter();
  });

  /* ---- Money format helper ------------------------------- */
  window.BB = window.BB || {};
  window.BB.formatMoney = function (cents, format) {
    const pounds = cents / 100;
    return `£${pounds.toFixed(2)}`;
  };

})();
